import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';
import moment from 'moment';

const EvacuationInfo = props => {
	const {
		startTime,
		employeesStart,
		employeesRemaining,
		employeesSave,
		type,
		replayTimeline,
	} = props;

	const getTime = startTime => {
		if (startTime) {
			return moment(startTime).format('MM-DD-YYYY HH:mm:ss');
		}
		return null;
	};

	return (
		<div className="evacuation-info">
			<div className="evacuation-info__timer">
				{props.children}
				{type === 'replay' && (
					<p>
						{' '}
						/ of Total evacuation time:{' '}
						<b>{replayTimeline.formatSec}</b>
					</p>
				)}
			</div>
			<p className="evacuation-info__property">
				<span>Evacuation Start time:</span>
				{type === 'replay' && (
					<strong>
						{moment(replayTimeline.start, 'x').format(
							'DD/MM/YYYY HH:mm:ss',
						)}
					</strong>
				)}
				{type === 'evacuation' && <strong>{getTime(startTime)}</strong>}
			</p>
			<p className="evacuation-info__property">
				<span>Total at start: </span>
				<strong>{employeesStart}</strong>
			</p>
			<p className="evacuation-info__property risk">
				<span>Total at risk: </span>
				<strong>{employeesRemaining}</strong>
			</p>

			<p className="evacuation-info__property safe">
				<span> Total safe:</span>
				<strong>{employeesSave}</strong>
			</p>
		</div>
	);
};

EvacuationInfo.defaultProps = {
	startTime: null,
	zones: [],
	employeesStart: 0,
	employeesRemaining: 0,
	employeesSave: 0,
};

EvacuationInfo.propTypes = {
	startTime: PropTypes.string,
	zones: PropTypes.array,
	employeesStart: PropTypes.number,
	employeesRemaining: PropTypes.number,
	employeesSave: PropTypes.number,
	replayTimeline: PropTypes.object,
};

export default EvacuationInfo;



// WEBPACK FOOTER //
// ./src/pages/evacuation-demo/components/evacuation-info/index.js